export const OPEN_FORM_LOADING = "OPEN_FORM_LOADING";
export const CLOSE_FORM_LOADING = "CLOSE_FORM_LOADING";
export const FORM_SUBMISSION_STATUS = "FORM_SUBMISSION_STATUS";
export const GET_ALL_ROLES = "GET_ALL_ROLES";
export const STORE_IMPERSONATE = "STORE_IMPERSONATE";
